import React from "react";
import { useFormContext } from "react-hook-form";
import { EMPTY_STRING, INPUT_TYPE } from "../../../constants/global.constants";

const InputField = ({
  name = EMPTY_STRING,
  type = INPUT_TYPE.TEXT,
  placeHolder = EMPTY_STRING,
  icon = null,
  isDisabled,
  className = EMPTY_STRING,
}) => {
  const { register } = useFormContext();

  return (
    <div className="position-relative">
      <input
        {...register(name)}
        type={type}
        className={`form-input-field ${className} ${
          icon ? "pe-5" : EMPTY_STRING
        }`}
        placeholder={placeHolder}
        autoComplete="new-password"
        disabled={isDisabled}
      />
      {icon}
    </div>
  );
};

export default InputField;
